(function () {
    'use strict';

    a3_cabin_reports.service("SyncAPIService", SyncAPIService);
    /**
     * @memberof CabinReports
     * @ngdoc service
     * @name SyncAPIService
     * @description 
     * Generic Sync service which sends all your reports and gets all the latest data
     * @ngInject
     */


    function SyncAPIService($http, $q, apiUrl, FlightFactory, ReportGuidFactory, CabinReportTemplateItemFactory, SyncLogFactory,
        CabinReportLocalEditFactory, CrewRouteFactory, CrewMealFactory, CabinReportSendToServerFactory, CabinReportSyncResultFactory, AircraftTypeFactory,
        DataCleanerFactory, WaterUpliftActionFactory, ACSupplyFactory, SpecialMealSourceFactory, SpecialMealTypeFactory, CCMSFactory, TravelValueIncompleteReasonFactory,
        CCMSCrewPositionFactory, MessageFactory, LogService, CrewAssessmentTemplateFactory, CrewAssessmentFactory, UserFactory,
        AssessmentSyncResultFactory, SettingsMain, PaxInfoFactory, MemoFactory, FaqFactory, GroundDutyFactory, MemoImagesFactory, AircaftPositionsFactory,
        AimsCrewMemosFactory, IncompleteServicesSourceFactory, LeaveRequestFactory, CourseFactory, CampaignFactory, CrewHotelFactory, LuggageComplianceFactory,
        ScheduleAcknowledgeFactory, CrewCallFactory, PreviousDutyFactory, LogCallFactory, CheckInFactory, PhiloxeniaQuestionsFactory, TimeLogFactory,
        FlightCheckInsFactory, AnnualLeavesFactory, FlightDelaysFactory, ToolkitFactory, CustomerEventFactory, ExpiriesFactory,
        TraineeCoursesDetailsFactory, RequestFactory, WifiAvailabilityFactory, FlightServiceEventsFactory, PassengerMealServiceFactory, GroomingCategoriesFactory,
        FlightOrdersFactory, SaFeedbackInfoFactory, SaCrewAssessmentFactory, SaAssessmentSyncResultFactory,
        ASSFSyncInfoFactory, ASSFReportFactory, JeppesenFlightDetailsFactory, AirlineInfoFactory, localStorageMD5Service, FlightMealCriteriaFactory,
        MisconnectionFlightsFactory, LotteryFactory) {

        /**
         * Find if a relative old flight exists and if exists update it 
         * @memberof SyncAPIService
         * @param {object} oldflight
         * @param {array} flights
         * @return {boolean} hasRelativeFlight
         */
        function relativeFlightMatcher(oldflight, flights) {
            var relativeFlights = [];
            var found = false;

            for (var i = 0; i < flights.length; i++) {
                if (oldflight.FlightNo == flights[i].FlightNo && oldflight.FlightDate == flights[i].FlightDate && oldflight.Departure == flights[i].Departure) {
                    relativeFlights.push(flights[i]);
                    found = true;
                    break;
                }
            }

            if (!found) {
                var flight = null;
                var oldFlightNo = null;
                var lastDigit = oldflight.FlightNo.substr(oldflight.FlightNo.length - 1, 1)

                oldFlightNo = (!isNaN(lastDigit)) ? oldflight.FlightNo : oldflight.FlightNo.substr(0, oldflight.FlightNo.length - 1);


                for (var i = 0; i < flights.length; i++) {
                    lastDigit = flights[i].FlightNo.substr(flights[i].FlightNo.length - 1, 1);

                    flight = (!isNaN(lastDigit)) ? flights[i].FlightNo : flights[i].FlightNo.substr(0, flights[i].FlightNo.length - 1);

                    if (oldFlightNo == flight && oldflight.FlightDate == flights[i].FlightDate && oldflight.Departure == flights[i].Departure) {
                        relativeFlights.push(flights[i]);
                    }
                }
            }

            if (relativeFlights.length == 1) {
                var cabinReportLocalEdit = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(oldflight.FlightId);
                cabinReportLocalEdit.FlightAimsId = relativeFlights[0].FlightAimsId;
                cabinReportLocalEdit.FlightId = relativeFlights[0].FlightId;
                CabinReportLocalEditFactory.setCabinReportToStorage(cabinReportLocalEdit);

                return true;
            } else if (relativeFlights.length > 1) {
                for (var i = 1; i < relativeFlights.length; i++) {
                    for (var j = 0; j < relativeFlights.length - i; j++) {
                        if (relativeFlights[j].FlightNo > relativeFlights[j + 1].FlightNo) {
                            var a = relativeFlights[j];
                            relativeFlights[j] = relativeFlights[j + 1];
                            relativeFlights[j + 1] = a;
                        }
                    }
                }

                var cabinReportLocalEdit = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(oldflight.FlightId);
                cabinReportLocalEdit.FlightAimsId = relativeFlights[0].FlightAimsId;
                cabinReportLocalEdit.FlightId = relativeFlights[0].FlightId;
                CabinReportLocalEditFactory.setCabinReportToStorage(cabinReportLocalEdit);

                return true;
            } else {
                return false;
            }
        };

        return {
            /**
             * Send and get the latest information 
             * @memberof SyncAPIService
             * @param {object} aimsId
             * @param {array} memoIdsToSend 
             */
            doSync: function (aimsId, memoIdsToSend) {
                //Clear timeLogs from local storage older than 2 days
                TimeLogFactory.cleanOldData();
                //clear CrewMeal ratings from local storage that have timestamp older than 20 days
                DataCleanerFactory.deleteOldCrewMealsRatings();
                // get the saved cabin reports
                var allSavedReports = CabinReportLocalEditFactory.getCabinReportsFromStorage();
                var IsAssessmentEnabled = SettingsMain.getIsAssessmentEnabled();
                var user = UserFactory.getUser();

                var lastLog = SyncLogFactory.getSyncLog();
                var lastSyncDate = lastLog.date;

                //Free to send all reports and assessments:
                var messagesToSend = MessageFactory.getUnsynchedReadMessages();

                // keep only the ones that are ready to be sent
                var reportsToSend = CabinReportSendToServerFactory.getCompletedListFromCabinReportLocalEdits(allSavedReports);
                var assessmentsToSend = [];
                if(user.position == 'SA'){
                    if (IsAssessmentEnabled ) {
                        assessmentsToSend = CrewAssessmentFactory.getAssementsReadyToSend();
                    }

                    //TODO: Get assf report ReadyToSend

                }
                
                var saAssessmentsToSend = [];
                if (user.position == 'FA') {
                    saAssessmentsToSend = SaCrewAssessmentFactory.getAssementsReadyToSend();
                }

                var passengersCampaignsToSend = CampaignFactory.getPaxAssignmentsFromStorage();

                var luggageCompliance = {
                    luggageComplianceReports: LuggageComplianceFactory.getLuggageComplianceFromStorage().filter(x => !x.isSynced)
                }

                //Get call requests made while offline
                var phoneCallLog = {
                    CrewCallReports: LogCallFactory.getLogCallsFromStorage()
                }

                var oneStopShopEvents = CustomerEventFactory.getUnsyncedCustomerEvents();

                var lotteryResultsToSend = LotteryFactory.getPendingResults() || [];

                var syncData = {
                    "SyncCabinReports": reportsToSend,
                    "Messages": messagesToSend,
                    "Assessments": assessmentsToSend,
                    "SaAssessments": saAssessmentsToSend,
                    "Memos": memoIdsToSend,
                    "PassengersCampaigns": passengersCampaignsToSend,
                    "LuggageCompliance": luggageCompliance,
                    "CrewCallLog" : phoneCallLog,
                    "LastSyncDate": lastSyncDate,
                    "OneStopShopEvents": oneStopShopEvents,
                    "LotteryResults": lotteryResultsToSend
                };

                var call = $q.defer();
                $http.post(apiUrl + '/sync', syncData, {
                    'Content-Type': 'application/json'
                })
                    .then(
                        function (responseData) {

                            if (responseData == undefined
                                || responseData.data == undefined
                                || responseData.data.data == undefined
                                || responseData.data.data.SyncCabinData == undefined) {
                                var err = new Error();
                                err.status = -1;
                                var msg = "ResponseData error in sync :" + JSON.stringify(responseData);

                                LogService.debug(msg, err)
                                call.reject(err);
                                return;
                            }
                            var response = responseData.data.data;


                            //keep flights, will be used to retain a flight for old unsynched reports
                            var orgFlights = FlightFactory.getFlightsFromStorage();
                            var IsAssessmentEnabled = response.SyncCabinData.IsAssessmentEnabled;

                            SettingsMain.setIsAssessmentEnabled(IsAssessmentEnabled);

                            //Save schedule changes dates 
                            ScheduleAcknowledgeFactory.setAllScheduleChangesToStorage(response.SyncCabinData.ScheduleChanges);
                            if (response.SyncCabinData.CrewCallLog && response.SyncCabinData.CrewCallLog.ResponseSuccess) {
                                LogCallFactory.cleanLogsFromStorage();
                            }
  
                            var oneStopShop = response.SyncCabinData.OneStopShop;
							//save toolkit items
                            if(oneStopShop.ToolkitItems){
                                ToolkitFactory.setToolkitItemsFromServer(oneStopShop.ToolkitItems);
                            }

							//check OneStopShop CustomerEvents save status
                            if(oneStopShop.CustomerEventsSynced){
                                oneStopShop.CustomerEventsSynced.forEach(function(event){
                                    var localCustomerEvent = oneStopShopEvents.find(x => x.TemporaryId == event.TemporaryId);
                                    localCustomerEvent.Synced = event.SaveSuccess;
                                    
                                    //No Treatment Id reset value
                                    if(localCustomerEvent.TreatmentId == null)
                                        localCustomerEvent.TreatmentId = -1;
    
                                    CustomerEventFactory.updateCustomerEvent(localCustomerEvent);
                                }); 
                            }
						

                            //save training courses
                            var rawTrainingCourses = response.SyncCabinData.TrainingCourses;
                            var courses = [];

                            rawTrainingCourses.forEach(function (course) {
                                courses.push({
                                    Id: course.Id,
                                    Title: course.Title,
                                    HasLimitedInfo: true
                                });
                            });  

                            CourseFactory.setCoursesFromServer(courses);

                            // Enable/Disable SITC from api settings 
                            var IsShopInTheCloudEnable = response.SyncCabinData.IsShopInTheCloudEnable;
                            SettingsMain.setIsShopInTheCloudEnable(IsShopInTheCloudEnable);

                            //clean crew member info
                            var responseFlightIds = response.SyncCabinData.flights.map(x => x.FlightId);
                            CrewCallFactory.cleanOldData(responseFlightIds);
                            PreviousDutyFactory.cleanOldData(responseFlightIds);
                            PhiloxeniaQuestionsFactory.cleanOldData(responseFlightIds);
                            LuggageComplianceFactory.cleanOldData(responseFlightIds);
                            AircaftPositionsFactory.cleanOldData(responseFlightIds);
                            FlightCheckInsFactory.cleanOldData(responseFlightIds);
                            ASSFReportFactory.cleanOldData(responseFlightIds);
                            JeppesenFlightDetailsFactory.cleanOldData(responseFlightIds);
                            FlightMealCriteriaFactory.cleanOldDataMealCriteria(responseFlightIds);

                            //TODO::move to refresh service:
                            //DataCleaner for the pax info (indexedDb)
                            var pendingFlightIds = CabinReportLocalEditFactory.getFlightIdsWithPendingReports();
                            PaxInfoFactory.cleanOldDataPaxInfo(pendingFlightIds);
                            //Data cleaner for the campaigns
                            CampaignFactory.cleanOldCampaigns(pendingFlightIds);
                            // //Data cleaner for the aims crew memos
                            // AimsCrewMemosFactory.cleanOldAimsCrewMemos();
                            AimsCrewMemosFactory.clearAimsCrewMemosFactoryFromStorage();
                            //Data cleaner for flight delays
                            FlightDelaysFactory.cleanOldFlightDelays(responseFlightIds);
                            //Clean old data for the flight service events
                            FlightServiceEventsFactory.cleanOldDataServiceEvents(pendingFlightIds);
                            //Clean old data for the flight Flight Orders
                            FlightOrdersFactory.cleanOldDataFlightOrders(pendingFlightIds);
                            MisconnectionFlightsFactory.cleanOldDataMisconnectionFlights(pendingFlightIds);

                            GroomingCategoriesFactory.clearGroomingReportsFromStorage();

                            //Data cleaner for the customer events (flightDate of the event >= today - 5 days)
                            // CustomerEventHistoryFactory.deleteOldHistoryEvents();
                            // CustomerEventFactory.deleteOldCustomerEvents();

                            // FlightGateFactory.processUpdatedData(response.SyncCabinData.flightGates);

                            // clear existing server data
                            DataCleanerFactory.deleteAllServerData();

                            var fromSync = true;
                            GroundDutyFactory.mergeGroundDutiesToStorage(response.SyncCabinData.groundDuties, fromSync);
                            CrewRouteFactory.setCrewRoutesToStorage(response.SyncCabinData.CrewRoutes);
                            CrewMealFactory.setCrewMealsToStorage(response.SyncCabinData.CateringCrewMeals);
                            CrewHotelFactory.setCrewHotelsToStorage(response.SyncCabinData.CrewHotels);
                            CheckInFactory.setCheckInInfoToStorage(response.CrewCheckInInfo);
                            FlightServiceEventsFactory.setEventTypes(response. FlightServiceEventTypes);
                            AnnualLeavesFactory.setAnnualLeavesToStorage(response.AnnualLeaves);
                            ExpiriesFactory.setCrewExpiriesToStorage(response.CrewExpiries);
                            AimsCrewMemosFactory.setAimsCrewMemosToStorage(response.SyncCabinData.aimsCrewMemos);
                            WifiAvailabilityFactory.setRegistrationsToStorage(response.RegistrationsWithWifi);
                            PassengerMealServiceFactory.checkAndsetPassengerMealsServicesToStorage(response.PassengerMealServices);
                            GroomingCategoriesFactory.setGroomingCategories(response.GroomingCategories);
                            ExpiriesFactory.setAllExpiriesToStorage(response.AllExpiries); 
                            
                            if(response.PassengerMealAncillaries){
                                PassengerMealServiceFactory.setPassengerMealsAncillariesToStorage(response.PassengerMealAncillaries);
                            }

                            // Store airline context (logos / selection)
                            AirlineInfoFactory.setCrewAirlineInfos(response.CrewAirlineInfos || []);
                            AirlineInfoFactory.setCrewAirlineOptions(response.CrewAirlineOptions || []);

                            // Backend default selection (preselected on page load)
                            var defaultFleetId =
                            response.SelectedAirline && response.SelectedAirline.FleetId
                                ? response.SelectedAirline.FleetId
                                : null;
                            // Only update the default in storage, do not re-initialize UI selection
                            AirlineInfoFactory.setDefaultFleetId(defaultFleetId);

                            if(response.RosterRequestAncillaries){
                                RequestFactory.setSubmissionDeadlineDateToStorage(response.RosterRequestAncillaries.SubmissionEndDate);
                            }

                            // If the sync response contains common flights with Flight Attendants (FA)
                            if (response.SyncCabinData.CommonFlightsWithFA) {
                                localStorageMD5Service.set('CommonFlightsWithFA', response.SyncCabinData.CommonFlightsWithFA);
                            }
                            // If the sync response contains common flights with Senior Attendants (SA)
                            if (response.SyncCabinData.CommonFlightsWithSA) {
                                localStorageMD5Service.set('CommonFlightsWithSA', response.SyncCabinData.CommonFlightsWithSA);
                            }

                            //save, update or add memos
                            var memos = response.SyncCabinData.memos;
                            MemoFactory.setMemosFromServer(memos, memoIdsToSend, lastSyncDate);

                            LeaveRequestFactory.saveLeaveRequestInformation(response.SyncCabinData.LeaveRequestInformation);

                            //delete leftover memos 
                            var serverMemoIds = response.SyncCabinData.memoIds;
                            for (var i = 0; i < serverMemoIds.length; i++) {
                                MemoFactory.deleteMemoFromStorage(serverMemoIds[i]);
                            }
                            for (var i = 0; i < memos.length; i++) {
                                MemoImagesFactory.deleteMemoImageByMemoId(memos[i].Id);
                            }
                            var images = response.SyncCabinData.Images;
                            MemoImagesFactory.setImagesToServer(images);
                            for (var i = 0; i < serverMemoIds.length; i++) {
                                MemoImagesFactory.deleteMemoImageByMemoId(serverMemoIds[i]);
                            }
                            // save flight data to local storage
                            var flightData = response.SyncCabinData.flights;
                            var flights = FlightFactory.markScheduleChangedFlights(flightData, orgFlights);

                            var cabinReports = response.SyncCabinData.cabinReports;
                            var assessmentTemplate = response.SyncCabinData.assessmentTemplate;
                            CrewAssessmentTemplateFactory.setCrewAssessmentTemplateToStorage(assessmentTemplate);
                            var reportGuids = response.SyncCabinData.guids;
                            ReportGuidFactory.setReportGuidsToStorage(reportGuids);

                            // save cabin report template to storage
                            var cabinReportTemplateItems = response.SyncCabinData.cabinReportTemplate;
                            CabinReportTemplateItemFactory.setCabinReportTemplateItemsToStorage(cabinReportTemplateItems);

                            //store and sync messages
                            var messages = response.SyncCabinData.messages;
                            MessageFactory.markReadAsSynched(messages);
                            MessageFactory.storeMessagesFromServer(messages);

                            // save aircraft types to local storage
                            var aircraftTypes = response.SyncCabinData.aircraftTypes;
                            AircraftTypeFactory.setAircraftTypesToStorage(aircraftTypes);

                            // save water uplift actions to local storage
                            var wuas = response.SyncCabinData.waterUpliftActions;
                            WaterUpliftActionFactory.setWaterUpliftActionsToStorage(wuas);

                            // save ac supplies to local storage
                            var acSupplies = response.SyncCabinData.acSupplies;
                            ACSupplyFactory.setACSuppliesToStorage(acSupplies);

                            // save special meal sources to local storage
                            var specialMealSources = response.SyncCabinData.specialMealSources;
                            SpecialMealSourceFactory.setSpecialMealSourcesToStorage(specialMealSources);

                            // save special meal types to local storage
                            var specialMealTypes = response.SyncCabinData.specialMealTypes;
                            SpecialMealTypeFactory.setSpecialMealTypesToStorage(specialMealTypes);

                            // save currencies to local storage
                            /*var currencies = response.SyncCabinData.currencies;
                            CurrencyFactory.setCurrenciesToStorage(currencies);*/

                            //save all FAQs to local storage
                            var FAQs = response.SyncCabinData.FAQPairs;
                            FaqFactory.setFAQsFromServer(FAQs);

                            // save lotteries to local storage
                            if (response.SyncCabinData.Lotteries) {
                                LotteryFactory.setLotteriesFromServer(response.SyncCabinData.Lotteries);
                            }
                            if (response.SyncCabinData.SubmittedLotteryResults) {
                                LotteryFactory.setSubmittedLotteriesFromServer(response.SyncCabinData.SubmittedLotteryResults);
                            }

                            // save currencies to local storage
                            var travelReasons = response.SyncCabinData.travelValueIncompleteReasons;
                            TravelValueIncompleteReasonFactory.setReasonsToStorage(travelReasons);

                            // save Incomplete In-Flight Services Reasons and Types:
                            var incompleteInFlightServiceListOfValues = response.SyncCabinData.incompleteInFlightServiceListOfValues;
                            IncompleteServicesSourceFactory.setIncompleteInFlightServiceListOfValues(incompleteInFlightServiceListOfValues);

                            // save SA Feedbacks: Questions & SA members
                            var saFeedbackInfo = response.SAFeedbackInfo;

                            if(saFeedbackInfo){
                                SaFeedbackInfoFactory.setSaFeedbacks(saFeedbackInfo);
                            }

                            if(response.ASSFSyncInfo){
                                ASSFSyncInfoFactory.setASSFInfo(response.ASSFSyncInfo);
                            }


                            // log the sync user and date
                            SyncLogFactory.setSyncLog(aimsId, response.SyncCabinData.version, response.SyncCabinData.toDate);

                            // save ccms to local storage
                            var ccms = response.SyncCabinData.ccms;

                            CCMSFactory.setCCMSToStorage(ccms);

                            var traineeCourses = response.SyncCabinData.TraineeCourses;
                            TraineeCoursesDetailsFactory.setTraineeCoursesToStorage(traineeCourses);

                            var traineeFlightCourses = response.SyncCabinData.TraineeFlightCourses;
                            TraineeCoursesDetailsFactory.setTraineeFlightCoursesToStorage(traineeFlightCourses);

                            // get the sync results
                            var syncResults = CabinReportSyncResultFactory.fromObjectList(response.SyncCabinData.reportResults);
                            var flight;
                            // mark sent reports as synched
                            for (var j = 0; j < reportsToSend.length; j++) {
                                var syncResult = CabinReportSyncResultFactory.getSyncResult(syncResults, reportsToSend[j].ReportGuid);

                                if (syncResult != null) {
                                    if (syncResult.success) {
                                        CabinReportLocalEditFactory.markReportAsSynched(reportsToSend[j].ReportGuid);
                                        syncResult.Result = 'Successfully submitted';
                                    } else {
                                        syncResult.Result = 'Submission error';
                                    }

                                    // find flight and append report fields
                                    flight = null;
                                    if (orgFlights != null) {
                                        for (i = 0; i < orgFlights.length; i++) {
                                            if ((orgFlights[i].FlightId != null && orgFlights[i].FlightId == reportsToSend[j].FlightId) || (orgFlights[i].FlightAimsId != null && orgFlights[i].FlightAimsId == reportsToSend[j].FlightAimsId)) {
                                                flight = orgFlights[i];
                                                break;
                                            }
                                        }
                                    }
                                    //var flight = FlightFactory.getFlightFromStorage(reportsToSend[j].FlightAimsId);

                                    if (flight != null) {
                                        syncResult.FlightAimsId = flight.FlightAimsId;
                                        syncResult.FlightId = flight.FlightId;
                                        syncResult.ScheduledDepartureDateUTC = flight.ScheduledDepartureDateUTC;
                                        syncResult.FlightNo = flight.FlightNo;
                                        syncResult.Departure = flight.Departure;
                                        syncResult.Arrival = flight.Arrival;
                                        syncResult.ScheduledDepartureTimeUTC = flight.ScheduledDepartureTimeUTC;
                                        syncResult.AcTailNo = flight.AcTailNo;
                                    }
                                }
                            }
                            // save the sync results
                            CabinReportSyncResultFactory.setCabinReportSyncResultsToStorage(syncResults);
                            AssessmentSyncResultFactory.setAssessmentSyncResultsToStorage(response.SyncCabinData.assessmentResults);
                            SaAssessmentSyncResultFactory.setAssessmentSyncResultsToStorage(response.SaAssessmentResults);

                            var lotterySyncResults = response.SyncCabinData.LotteryResultSyncResults || [];
                            var lotterySyncSummary = [];

                            for (var l = 0; l < lotterySyncResults.length; l++) {
                                var lotterySyncResult = lotterySyncResults[l];
                                var compositeId = lotterySyncResult.LotteryId + "_" + lotterySyncResult.FlightId;

                                if (lotterySyncResult.Success || lotterySyncResult.IsDuplicate) {
                                    LotteryFactory.removePendingResult(compositeId);
                                }

                                var lotteryObj = LotteryFactory.getLotteryById(lotterySyncResult.LotteryId);
                                var sentMatch = lotteryResultsToSend.filter(function (s) {
                                    return s.LotteryId == lotterySyncResult.LotteryId && s.FlightId == lotterySyncResult.FlightId;
                                })[0];
                                lotterySyncSummary.push({
                                    LotteryId: lotterySyncResult.LotteryId,
                                    FlightId: lotterySyncResult.FlightId,
                                    FlightDisplay: (sentMatch && sentMatch.FlightDisplay) || ('Flight #' + lotterySyncResult.FlightId),
                                    LotteryName: lotteryObj ? lotteryObj.Name : ('Lottery #' + lotterySyncResult.LotteryId),
                                    Success: !!(lotterySyncResult.Success || lotterySyncResult.IsDuplicate),
                                    IsDuplicate: !!lotterySyncResult.IsDuplicate,
                                    ErrorMessage: lotterySyncResult.ErrorMessage || null
                                });
                            }

                            // Flag any sent items that received no server response
                            for (var m = 0; m < lotteryResultsToSend.length; m++) {
                                var sentItem = lotteryResultsToSend[m];
                                var alreadyInSummary = lotterySyncSummary.some(function (r) {
                                    return r.LotteryId == sentItem.LotteryId && r.FlightId == sentItem.FlightId;
                                });
                                if (!alreadyInSummary) {
                                    var missedLotteryObj = LotteryFactory.getLotteryById(sentItem.LotteryId);
                                    lotterySyncSummary.push({
                                        LotteryId: sentItem.LotteryId,
                                        FlightId: sentItem.FlightId,
                                        FlightDisplay: sentItem.FlightDisplay || ('Flight #' + sentItem.FlightId),
                                        LotteryName: missedLotteryObj ? missedLotteryObj.Name : ('Lottery #' + sentItem.LotteryId),
                                        Success: false,
                                        IsDuplicate: false,
                                        ErrorMessage: 'No response received from server'
                                    });
                                }
                            }
                            // delete local flights with no local reports
                            DataCleanerFactory.deleteOrphanedLocalFlights();

                            //**************** ADD CODE TO KEEP FLIGHTS IF THEY STIL HAVE AN NOT SYCNHED REPORT *********************//
                            //find flight ids used by draft reports
                            //**************** ADD CODE TO KEEP FLIGHTS IF THEY STIL HAVE AN NOT SYCNHED REPORT *********************//
                            //find flight ids used by draft reports
                            if (allSavedReports) {
                                var verifyFlightAimsIds = [];
                                var verifyFlightIds = [];
                                for (var i = 0; i < allSavedReports.length; i++) {
                                    if (allSavedReports[i].Status == 'draft' || allSavedReports[i].Status == 'completed')
                                        verifyFlightAimsIds.push(allSavedReports[i].FlightAimsId);
                                    verifyFlightIds.push(allSavedReports[i].FlightId);
                                }
                                //search these ids into the newly received flights
                                if (verifyFlightAimsIds.length > 0) {
                                    var missingIds = [];
                                    var missingAimsIds = [];
                                    var found, id, aimsId;
                                    for (var i = 0; i < verifyFlightAimsIds.length; i++) {
                                        found = false;
                                        aimsId = verifyFlightAimsIds[i];
                                        id = verifyFlightIds[i];
                                        for (var f = 0; f < flights.length; f++) {
                                            if ((flights[f].FlightId != null && flights[f].FlightId == id) || (flights[f].FlightAimsId != null && flights[f].FlightAimsId == aimsId)) {
                                                found = true;
                                                break;
                                            }
                                        }
                                        if (!found)
                                            missingIds.push(id);
                                        missingAimsIds.push(aimsId);
                                    }
                                    //search missing flights in flights stored before sync
                                    if (orgFlights) {
                                        for (var m = 0; m < missingIds.length; m++) {
                                            id = missingIds[m];
                                            aimsId = missingAimsIds[m];
                                            for (var o = 0; o < orgFlights.length; o++) {
                                                if ((orgFlights[o].FlightId != null && orgFlights[o].FlightId == id) || (orgFlights[o].FlightAimsId != null && orgFlights[o].FlightAimsId == aimsId)) {
                                                    if (!relativeFlightMatcher(orgFlights[o], flights)) {
                                                        flights.push(orgFlights[o]);
                                                    }
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                            FlightFactory.storeFlightsWithReportsAndMessages(flights, cabinReports, messages);
                            
                            //Fix Assessments in LS: FA and SA
                            CrewAssessmentFactory.updateAndMergeAllFaAssessments(response.SyncCabinData.assessments);
                            //update SA Feedbacks/Assessments
                            if(saFeedbackInfo){
                                SaCrewAssessmentFactory.updateAndMergeAllSaAssessments(saFeedbackInfo.Assessments);
                            }

                            //Update the assfReport obj for each flight in schedule
                            if(response.ASSFSyncInfo){
                                ASSFReportFactory.updateFlightsAssfStatus(response.ASSFSyncInfo.SyncedFlightIds);
                            }

                            //TimeLogFactory.timeLogToStorage(timeLog, response.SyncCabinData.timelog);

                            // attach lottery sync summary for the sync results modal
                            responseData.lotterySyncSummary = lotterySyncSummary;

                            // return true
                            call.resolve(responseData);
                        },
                        function (err) {
                            call.reject(err);
                        }
                    );
                return call.promise;
            },
            /**
             * Update local reports from synced Fligths 
             * @memberof SyncAPIService
             */
            updateCabinReportLocalEditFromSynch: function () {
                var cabinReportLocalEdits = CabinReportLocalEditFactory.getCabinReportsFromStorage();
                if (cabinReportLocalEdits != undefined && cabinReportLocalEdits != null) {
                    for (var i = 0; i < cabinReportLocalEdits.length; i++) {
                        var flight = FlightFactory.getFlightFromStorage(cabinReportLocalEdits[i].FlightId, cabinReportLocalEdits[i].FlightAimsId);
                        if ((cabinReportLocalEdits[i].Status == "draft" || cabinReportLocalEdits[i].Status == "completed") && (flight)) {

                            //console.log(cabinReportLocalEdits[i].FlightAimsId);
                            cabinReportLocalEdits[i].Departure = flight.Departure;
                            cabinReportLocalEdits[i].Arrival = flight.Arrival;
                            cabinReportLocalEdits[i].AcType = flight.AcType;
                            cabinReportLocalEdits[i].AcTailNo = flight.AcTailNo;
                            cabinReportLocalEdits[i].FlightNo = flight.FlightNo;
                            cabinReportLocalEdits[i].DepartureICAO = flight.DepartureICAO;
                            cabinReportLocalEdits[i].DepartureCountry = flight.DepartureCountry;
                            cabinReportLocalEdits[i].DepartureName = flight.DepartureName;
                            cabinReportLocalEdits[i].ArrivalICAO = flight.ArrivalICAO;
                            cabinReportLocalEdits[i].ArrivalCountry = flight.ArrivalCountry;
                            cabinReportLocalEdits[i].ArrivalName = flight.ArrivalName;
                            cabinReportLocalEdits[i].ScheduledDepartureDateUTC = flight.ScheduledDepartureDateUTC;
                            cabinReportLocalEdits[i].ScheduledDepartureTimeUTC = flight.ScheduledDepartureTimeUTC;
                            cabinReportLocalEdits[i].ScheduledDeparture = flight.ScheduledDeparture;
                            cabinReportLocalEdits[i].BookedC = flight.BookedC;
                            cabinReportLocalEdits[i].BookedY = flight.BookedY;
                            cabinReportLocalEdits[i].BookedInf = flight.BookedInf;
                            cabinReportLocalEdits[i].BookedPad = flight.BookedPad;
                            cabinReportLocalEdits[i].BookedChld = flight.BookedChld;
                            cabinReportLocalEdits[i].ActualC = flight.ActualC;
                            cabinReportLocalEdits[i].ActualY = flight.ActualY;
                            cabinReportLocalEdits[i].ActualInf = flight.ActualInf;
                            cabinReportLocalEdits[i].ActualPad = flight.ActualPad;
                            cabinReportLocalEdits[i].ActualChld = flight.ActualChld;

                            cabinReportLocalEdits[i].DepartureGate = flight.DepartureGate;
                            cabinReportLocalEdits[i].DepartureTimezone = flight.DepartureTimezone;
                            cabinReportLocalEdits[i].ArrivalTimezone = flight.ArrivalTimezone;
                            cabinReportLocalEdits[i].CallSign = flight.CallSign;
                            cabinReportLocalEdits[i].ScheduledArrival = flight.ScheduledArrival;
                            cabinReportLocalEdits[i].Route = flight.Route;
                            cabinReportLocalEdits[i].DutyDate = flight.DutyDate;

                            var manualCCMSCrewPositions = []
                            for (var k = 0; k < cabinReportLocalEdits[i].CCMSCrewPositions.length; k++) {
                                if (cabinReportLocalEdits[i].CCMSCrewPositions[k].IsManual) {
                                    manualCCMSCrewPositions.push(cabinReportLocalEdits[i].CCMSCrewPositions[k]);
                                }
                            }

                            cabinReportLocalEdits[i].crew = flight.crew;
                            var newCCMSCrewPositions = [];
                            var IsNew;
                            var changeStatus = false;

                            for (var h = 0; h < cabinReportLocalEdits[i].crew.length; h++) {
                                if ((cabinReportLocalEdits[i].crew[h].isDHC == false) &&
                                    (cabinReportLocalEdits[i].crew[h].position != 'CP') &&
                                    (cabinReportLocalEdits[i].crew[h].position != 'FO')) {
                                    var crewPosition = CCMSCrewPositionFactory.createNew();
                                    crewPosition.CrewId = cabinReportLocalEdits[i].crew[h].aimsId;
                                    crewPosition.Initials = cabinReportLocalEdits[i].crew[h].shortname;
                                    crewPosition.Name = cabinReportLocalEdits[i].crew[h].name;
                                    crewPosition.Position = cabinReportLocalEdits[i].crew[h].position;
                                    crewPosition.IsManual = false;
                                    IsNew = false;
                                    for (var k = 0; k < cabinReportLocalEdits[i].CCMSCrewPositions.length; k++) {
                                        if (flight.crew[h].aimsId == cabinReportLocalEdits[i].CCMSCrewPositions[k].CrewId) {
                                            crewPosition.CCMS = cabinReportLocalEdits[i].CCMSCrewPositions[k].CCMS;
                                           crewPosition.CrewComments = cabinReportLocalEdits[i].CCMSCrewPositions[k].CrewComments;
                                           crewPosition.AdditionalFeedbackId = cabinReportLocalEdits[i].CCMSCrewPositions[k].AdditionalFeedbackId;
                                           crewPosition.Route = cabinReportLocalEdits[i].Route;
                                            if (crewPosition.CCMS == null) {
                                                IsNew = true;
                                            }
                                            break;
                                        }
                                    }
                                    if (IsNew) {
                                        changeStatus = true;
                                    }
                                    newCCMSCrewPositions.push(crewPosition);
                                }
                            }
                            if (changeStatus) {
                                cabinReportLocalEdits[i].Status = "draft";
                            }
                            cabinReportLocalEdits[i].CCMSCrewPositions = newCCMSCrewPositions.concat(manualCCMSCrewPositions);

                        }
                    }

                    CabinReportLocalEditFactory.setCabinReportsToStorage(cabinReportLocalEdits);
                }
            }
        };
    }

})();